import './DynaCaptcha.scss';
import {useEffect, useState} from "react";
import StringToSVG from "../../../utils/StringToSVG";

const DynaCaptcha = ({length, fontSize, textColor, renderCaptcha, setTextCaptcha}) => {

  const [randomText, setRandomText] = useState(generateRandomText(length));

  function generateRandomText(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  useEffect(() => {
    const newRandomText = generateRandomText(length);
    setRandomText(newRandomText);
    setTextCaptcha(newRandomText)
  }, [length, renderCaptcha]);

  return (
    <div>
      <StringToSVG
        inputString={randomText}
        fontSize={fontSize}
        textColor={textColor}
        backgroundColor="transparent"
      />
    </div>
  );
};

export default DynaCaptcha;